(function ($) {
  $('.js-quantity').on('click', '.js-plus, .js-minus', function () {
    var $this = $(this);
    var $container = $this.closest('.js-quantity');
    var $input = $container.find('input');

    var step = parseInt($input.attr('step')) || 1;
    var val = parseInt($input.val());
    var min = parseInt($input.attr('min')) || 0;
    var max = parseInt($input.attr('max')) || null;

    val = isNaN(val) ? step : val;

    var next = $this.hasClass('js-minus') ? val - step : val + step;

    // fix bad stepping
    next = next - (next % step);

    if (max && next > max) {
      next = max;
    } else if (next < min) {
      next = min;
    }

    $input.val(next);
  });
})(jQuery);
